import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { AbcAnalyseListView } from "./list-view/abcanalyse.list-view";


export const abcanalyseFieldOk: FieldOkConfig = {
  name: 'abcanalyse',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{analyse}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: AbcAnalyseListView,
    }
  }
  ]
};
export const abcanalyseMultiselectFieldOk: FieldOkConfig = {
  name: 'abcanalyse',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{analyse}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: AbcAnalyseListView,
    }
  }
  ]
};

export const abcanalyseQueryFieldOk: FieldOkConfig = {
  name: 'abcanalyse',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{analyse}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: AbcAnalyseListView,
    }
  }
  ]
};
